export class Campaign {
    id: number;
    embedCode: string;
    hasCompanion: boolean;
    brand: string;
    product: string;
    totalAllocatedViews: number;
    totalAllocatedViewsPerDay: number;
    totalAllocatedViewsPerUser: number;
    minAge: number;
    maxAge: number;
    countryId: number;
    providerId: number;
    startDateUtc: Date;
    endDateUtc: Date;
    isAndroid: boolean;
    isMale: boolean;
    brandLogoId?: number;
    isAvailable: boolean;
    is18PlusContent: boolean;
    isGridContentType: boolean;
    isAdvertisingIdRequired: boolean;
    floorPrice: number;
    value: number;
    //taxonomy
    dsp: string;
    ssp: string;
    tradingDesk: string;
    isServerSide: boolean;
    isPrePaidConsumer: boolean;
    isPostPaidConsumer: boolean;
    isPostPaidCorporate: boolean;
}

export class CampaignExtraDetails {
    publisherCampaignAllocations: Array<PublisherCampaignAllocation>;
    campaignPpa: Array<CampaignPpa>;
}

export class CampaignPpa {
    id: number;
    campaignId: number;
    ppaType: number;
    ppaTypeName: string;
    order: number;
    renderedTemplate: number;
    displayProbability: number;
    isLive: boolean;
    clickThroughUrl: string;
    facebookShareUrl: string;
    twitterShareUrl: string;
}

export class PublisherCampaignAllocation {
    id: number;
    publisherId: number;
    publisherName: string;
    campaignId: number;
    totalAllocatedViews: number;
    totalAllocatedViewsPerDay: number;
    totalRequestsPerUserPerDay: number;
    publisherCpe: number;
    startUtc: Date;
    endUtc: Date;
    isAvailable: boolean;
}

export interface ICampaignViewModel {
    campaign: Campaign;
    countryCode: string;
    nrRatings: number;
    avgRatings: number;
    totalPlaysCount: number;
    totalCompletedViewsCount: number;
    totalEarnings: number;
    deliveryIndex: number;
    avgCompletedViewsPerDay: number;
    delivered: number;
    timeElapsed: number;
    clicksCount: number;
    ctr: number;
    sharesCount: number;
    str: number;
    interactions: number;
    itr: number;
}




// WEBPACK FOOTER //
// ./src/app/campaigns/campaign.model.ts